import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ErrorsService {
  constructor(private translate: TranslateService) {}

  getErrorString(element) {
    return element.errors
      ? Object.values(element.errors)
          .map((e: any) => {
            if (typeof e === 'string') {
              return this.translate.instant(String(e));
            } else {
              return this.translate.instant(e.name, { index: e.params.index });
            }
          })
          .join(' / ')
      : '';
  }

  getErrors(data: {}) {
    return !data
      ? null
      : Object.values(data)
          ?.map((e: any) => {
            if (typeof e === 'string') {
              return !e.length ? null : this.translate.instant(String(e));
            } else if (typeof e?.name === 'string') {
              return !e.name.length
                ? null
                : this.translate.instant(e.name, { index: e.params?.index });
            }
            return null;
          })
          .filter((v: any) => v);
  }

  getWarnings(data: {}) {
    return !data
      ? null
      : Object.values(data)
          ?.map((w: any) => (!w?.length ? null : this.translate.instant(String(w))))
          .filter((v: any) => v);
  }
}
